import {Injectable} from '@angular/core';
import {AuthService, EventService, User} from '@spartacus/core';
import {UserAccountFacade} from '@spartacus/user/account/root';
import {distinctUntilChanged} from 'rxjs/operators';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {EddlLoginEvent} from './events/eddl-login-event';
import {EddlLogoutEvent} from './events/eddl-logout-event';
import {Observable} from 'rxjs';
import {IFrameMessageService} from '../../iframe/iframe-message.service';
import {SessionStorageService} from '@dcp/configurator';

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
export class DcpEddlLoginStateService {

  isLoggedIn: boolean = false;
  user$: Observable<User>;

  constructor(
    private authService: AuthService,
    private userAccountFacade: UserAccountFacade,
    private iFrameMessageService: IFrameMessageService,
    protected sessionStorageService: SessionStorageService,
    protected eventService: EventService,
  ) {
    this.init();
  }

  private init() {
    this.getSessionStorage();
    this.setLoggedIn();
    this.setUser();
  }

  private getSessionStorage(): void {
    this.isLoggedIn = this.sessionStorageService.getItem('isLoggedIn') === 'true';
  }

  private throwEvent(isLoggedIn: boolean): void {
    if (isLoggedIn) {
      if (!this.iFrameMessageService.isIframe()) {
        this.eventService.dispatch(new EddlLoginEvent());
      }
    } else {
      this.eventService.dispatch(new EddlLogoutEvent());
    }
  }

  private setSessionStorage(isLoggedIn: boolean): void {
    this.sessionStorageService.setItem('isLoggedIn', Boolean(isLoggedIn).toString());
    this.isLoggedIn = isLoggedIn;
  }

  private setLoggedIn(): void {
    setTimeout(() => {
      this.authService.isUserLoggedIn().pipe(
        distinctUntilChanged(),
        untilDestroyed(this)
      ).subscribe(
        (isLoggedIn) => {
          if (isLoggedIn !== this.isLoggedIn) {
            this.isLoggedIn = isLoggedIn;
            this.throwEvent(isLoggedIn);
            this.setSessionStorage(isLoggedIn);
          }
        });
    });
  }

  public getLoginMethod(): 'manual' | 'auto' {
    const loginMethod = this.sessionStorageService.getItem('loginMethod') === 'manual' ? 'manual' : 'auto';
    this.sessionStorageService.removeItem('loginMethod');
    return loginMethod;
  }

  public getUser(): Observable<User> {
    return this.user$;
  }

  private setUser(): void {
    this.user$ = this.userAccountFacade.get()
      .pipe(
        distinctUntilChanged(),
        untilDestroyed(this)
      );
  }

}
